/**
 * This file is kept for backward compatibility.
 * The component is now in @punchup/ui-common package.
 */
export { default } from "@punchup/ui-common/components/common/icons/DownloadOnTheAppStore";
